<template>
  <v-row class="upcoming-info">
    <v-col sm="6" xs="12">
      <span class="asterisk" v-if="alarm">*&nbsp;</span>{{ param }}
    </v-col>
    <v-col sm="6" xs="12">
      {{ value }}
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: 'InfoRow',
  props: {
    param: {
      type: String,
    },
    value: {
      type: String,
    },
    alarm: {
      type: Boolean,
    },
  },
};
</script>

<style lang="scss" scoped>
.upcoming-info {

  .asterisk {
    color: $main-pink;

    body.binance & {
      color: $b-main-pink;
    }
  }
  .col:first-child {
    text-transform: none;
  }
}
</style>
